import { render, staticRenderFns } from "./BaseKeyValueList.vue?vue&type=template&id=77c09cb2"
import script from "./BaseKeyValueList.vue?vue&type=script&lang=js"
export * from "./BaseKeyValueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports